import { ShieldQuestion, EyeOff, AlertTriangle, Umbrella } from "lucide-react";
const consultationImg = "/lovable-uploads/c9a2b462-4f2a-4b10-97d2-0f2fd9eb6c23.webp";

const items = [
  { icon: AlertTriangle, label: "Ich zahle zu viel Steuern – und weiß nicht wie ich legal weniger zahlen kann" },
  { icon: EyeOff, label: "Ich verpasse staatliche Förderungen für meine Altersvorsorge" },
  { icon: ShieldQuestion, label: "Mein Geld liegt auf dem Konto und verliert durch Inflation an Wert" },
  { icon: Umbrella, label: "Ich weiß nicht, welche Vorsorge wirklich zu mir passt" },
];

export default function PainPoints() {
  return (
    <section className="py-20 md:py-28 bg-background">
      <div className="container">
        <div className="max-w-3xl mx-auto text-center reveal">
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-primary text-balance">
            Viele unserer Kunden standen vor ähnlichen Herausforderungen
          </h2>
        </div>

        <div className="mt-12 grid lg:grid-cols-2 gap-10 lg:gap-14 items-center">
          <div className="reveal">
            <div className="relative rounded-2xl overflow-hidden shadow-elegant border border-border">
              <img
                src={consultationImg}
                srcSet="/lovable-uploads/c9a2b462-4f2a-4b10-97d2-0f2fd9eb6c23-640.webp 640w, /lovable-uploads/c9a2b462-4f2a-4b10-97d2-0f2fd9eb6c23-960.webp 960w, /lovable-uploads/c9a2b462-4f2a-4b10-97d2-0f2fd9eb6c23.webp 1200w"
                sizes="(min-width: 1024px) 600px, 100vw"
                alt="Persönliche Finanzberatung in Hamburg"
                width={1200}
                height={933}
                loading="lazy"
                decoding="async"
                className="w-full h-full object-cover object-[62%_center] md:object-[68%_center] aspect-[4/5]"
              />
            </div>
          </div>

          <div className="flex flex-col gap-4">
            {items.map(({ icon: Icon, label }, i) => (
              <div
                key={i}
                className="reveal group rounded-2xl bg-card border border-border p-5 shadow-card hover:shadow-elegant hover:-translate-y-1 transition-all duration-300 flex items-center gap-5"
              >
                <div className="shrink-0 w-12 h-12 rounded-xl bg-accent-soft text-accent flex items-center justify-center group-hover:bg-accent group-hover:text-accent-foreground transition-colors">
                  <Icon className="w-6 h-6" />
                </div>
                <p className="text-base md:text-lg font-medium text-foreground leading-snug">{label}</p>
              </div>
            ))}
          </div>
        </div>

        <p className="mt-12 text-center text-lg text-muted-foreground reveal">
          Steueroptimierte Vorsorge & renditeorientierter Vermögensaufbau – digital und bundesweit.
        </p>
      </div>
    </section>
  );
}
